<template>
	<div class="omapi-statswidget omapi-card__flex">
		<div class="omapi-statswidget__heading flex">
			<h5>{{ title }}</h5>
			<common-date-select
				:minDate="minDate"
				:filter="dateRange.filter"
				@quickSelect="updateFilter"
				@dateSelection="fetchStatsFromDateRange"
			/>
		</div>
		<slot></slot>
		<common-card size="third" class="omapi-statswidget__nums">
			<div class='omapi-statswidget__stat'>{{ impressions }}</div>
			<div class='omapi-statswidget__desc'>Visitors</div>
		</common-card>
		<common-card size="third" class="omapi-statswidget__nums">
			<div class='omapi-statswidget__stat'>{{ conversions }}</div>
			<div class='omapi-statswidget__desc'>Subscribers / Leads</div>
		</common-card>
		<common-card size="third" class="omapi-statswidget__nums">
			<div class='omapi-statswidget__stat'>{{ rate }}%</div>
			<div class='omapi-statswidget__desc'>Conversion Rate</div>
		</common-card>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
	props : {
		title : {
			default : 'Quick Stats',
			type    : String,
		},
	},
	computed : {
		...mapState('dashboard', [ 'dateRange' ]),
		...mapGetters('dashboard', [ 'impressions', 'conversions', 'rate' ]),
		minDate () {
			return new Date(this.$store.state.dashboard.minDate)
		},
	},
	methods : {
		updateFilter (dateRange) {
			if ('custom' === dateRange) {
				return this.$store.commit('dashboard/updateDateRange', {
					filter : 'custom',
					preset : false,
				})
			}

			const payload = {
				filter : dateRange,
				preset : true,
				start  : '',
				end    : '',
			}

			// We know what dates to use so we can fetch the stats now
			this.$store.commit('dashboard/updateDateRange', payload)
			this.$store.dispatch('dashboard/fetch', payload)
		},
		fetchStatsFromDateRange (args) {
			const payload = {
				...args,
				preset : false,
			}
			this.$store.commit('dashboard/updateDateRange', payload)
			this.$store.dispatch('dashboard/fetch', payload)
		},
	},
}
</script>

<style lang="scss">
	@import '../../assets/scss/variables';
	.omapi-screen .omapi-statswidget {
		flex-basis: 100%;
		&__heading {
			flex-basis: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			h5 {
				font-size: 16px;
				line-height: 140%;
			}

			.omapi-dropdown__select .omapi-dropdown__toggle {
				width: 168px;
				margin: 0;
			}
		}
		&__nums {
			text-align: center;
			flex-basis: calc(33.33333333% - 10.5px);
		}
		&__stat {
			font-size: 48px;
			font-weight: $font_bold;
			line-height: 130%;
		}
		&__desc {
			color: $font_secondary-color;
			font-size: 18px;
			margin-top: 5px;
		}
	}
</style>
